<template>
  <div>
    <span class="sr-only">{{ getAriaText(params) }}</span>
    <c-open-order-entry
      :action="action"
      :buyAction="params.buyAction"
      :sellAction="params.sellAction"
      :limit="params.value"
      :embedded="params.embedded"
      :ric="ric"
      ticketType="stock"
      :quantity="defaultQuantity"
      accountId=""
      ref="oeButton"
    >
      <c-tick-flash :value="params.value">
        {{ params.valueFormatted }}
      </c-tick-flash>
    </c-open-order-entry>
  </div>
</template>

<script>
import Vue from 'vue';
import CTickFlash from '@custom/CTickFlash';
import COpenOrderEntry from '@custom/COpenOrderEntry';
import { getAriaText } from '@utils/helpers';

export default Vue.extend({
  name: 'price-quote-renderer',
  components: {
    CTickFlash,
    COpenOrderEntry
  },
  computed: {
    action() {
      return this.params.colDef.field.includes('bid') ? 'bid' : 'ask';
    },
    ric() {
      return this.params.ric;
    },
    defaultQuantity() {
      return this.$store.state.applicationSettings.orders.settings.stocks.defaultOrderQuantity;
    }
  },
  methods: {
    getAriaText
  }
});
</script>

<style lang="scss">
button.price-quote-renderer {
  color: inherit;
  margin-right: 0px !important;

  &:hover {
    color: inherit;
  }
}
</style>
